import { MprcConfirmDialog, MprcRequestIndicator } from "components";
import { useSnackbar } from "notistack";
import { useCoreApi } from "providers/CoreApiProvider";
import { useState } from "react";
import { useTranslation } from "react-i18next";

////////////////////////////////////////////////////////////////////////////////

interface IPros {
    inviteId: string;
    notificationId: string;
    channelName: string;
    onClose: () => void;
}

export const ChannelProcessInviteDialog = (props: IPros) => {
    const { inviteId, notificationId, channelName, onClose, } = props;

    const api = useCoreApi();
    const { enqueueSnackbar } = useSnackbar();
    const { t } = useTranslation("knowledge");
    const [posting, setPosting] = useState<boolean>(false);

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return <>
        <MprcRequestIndicator type="post" visible={posting} />

        <MprcConfirmDialog
            open
            message={t("Channel.ChannelProcessInviteDialog.MessageText", { name: channelName })}
            onClose={(accepted) => {
                if (accepted != null) {
                    setPosting(true);
                    api.v1.channelManagement.inviteProcess({ inviteId, notificationId, accepted })
                        .then(() => enqueueSnackbar(t(accepted ? "Feed.Channel.InviteAcceptSuccessfull" : "Feed.Channel.InviteRefuseSuccessfull"), { variant: "success" }))
                        .catch(() => enqueueSnackbar(t("Feed.Channel.InviteFailed"), { variant: "error" }))
                        .finally(() => onClose());
                }
                else {
                    onClose();
                }
            }}
        />
    </>;

};
